/**
 * @description 转换html样式
 */
const SECINDARY_COLORS = ['rgb(136, 136, 136)', 'rgb(68, 68, 68)'];
const TERIARY_COLORS = ['rgb(187, 187, 187)'];
const SHOPEE_COLORS = [
  'rgb(230, 0, 0)',
  'rgb(255, 153, 0)',
  'rgb(255, 255, 0)',
  'rgb(250, 204, 204)',
  'rgb(255, 235, 204)',
  'rgb(255, 255, 204)',
  'rgb(240, 102, 102)',
  'rgb(255, 194, 102)',
  'rgb(255, 255, 102)',
  'rgb(238, 77, 45)',
];

const handleColorReplace = (text: string) => {
  const color = text.split('color:')[1];

  if (SECINDARY_COLORS.includes(color)) {
    return 'color:rgba(0, 0, 0, 0.65)';
  } else if (TERIARY_COLORS.includes(color)) {
    return 'color:rgba(0, 0, 0, 0.54)';
  } else if (SHOPEE_COLORS.includes(color)) {
    return 'color:rgba(238, 77, 45, 1)';
  } else {
    return 'color:rgba(0, 0, 0, 0.87)';
  }
};

export const formatHtml = (text: string) => {
  const textColorRegex = /color:rgb?\(([^\)]*)\)/g;
  const noFillColorRegex = /background-color:rgba?\(([^\)]*)\)/g;

  const result = text
    .replace(textColorRegex, handleColorReplace)
    .replace(noFillColorRegex, 'background-color:transparent');

  return result;
};
